import { render, staticRenderFns } from "./centerHtml.vue?vue&type=template&id=4f0095fc&scoped=true&"
import script from "./centerHtml.vue?vue&type=script&lang=js&"
export * from "./centerHtml.vue?vue&type=script&lang=js&"
import style0 from "./centerHtml.vue?vue&type=style&index=0&id=4f0095fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0095fc",
  null
  
)

export default component.exports